import { Icon } from '@perch-labs/shrike';
import { ReactElement } from 'react';
import mx3 from 'static/mx-images/MX-Awate Serequeberhan.png';
import mx1 from 'static/mx-images/MX-Emily-Crick.png';
import mx5 from 'static/mx-images/MX-Joe-Flannery.png';
import mx2 from 'static/mx-images/MX-Laura-Yonamine.png';
import mx4 from 'static/mx-images/MX-image.png';
import { Link } from '~/components/link';
import { Separator } from '~/components/separator';
import { Text } from '~/components/typography';
import { useDialog } from '~/hooks';
import { theme as lightMode } from '~/styles';
import { TRACK, trackEvent } from '~/utils/tracking';
import { StyledModal as Dialog } from '../dialog.style';
import { ContactMethodContainer, MxHeadBubbleContainer, MxHeadBubble } from './help.style';

const photos = [
  { id: 1, src: mx1 },
  { id: 2, src: mx2 },
  { id: 3, src: mx3 },
  { id: 4, src: mx4 },
  { id: 5, src: mx5 },
];

interface Props {
  isSmb?: boolean;
  phoneNumber?: string;
  target: ReactElement;
}

export const HelpDialog = ({ isSmb = false, phoneNumber = '866-526-0083', target }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);
  const email = isSmb ? 'business.support@arcadia.com' : 'support@arcadia.com';

  return (
    <>
      {TargetComponent}
      <Dialog aria-label="Help Dialog" isOpen={isOpen} onDismiss={close} theme={lightMode}>
        <Dialog.HeaderCentered title="Our team is here to help" onClose={close} />
        <Text textAlign="center" paddingTop={16} px={5}>
          The Arcadia Support team is happy to answer any questions you have. We’re available Monday
          to Friday,
        </Text>
        <Text textAlign="center" paddingBottom={16} px={5}>
          9:00 am to 5:00 pm ET
        </Text>
        <ContactMethodContainer>
          <MxHeadBubbleContainer style={{ paddingTop: '32px', paddingBottom: '32px' }}>
            {photos.map(photo => (
              <MxHeadBubble src={photo.src} key={photo.id} />
            ))}
          </MxHeadBubbleContainer>
          <Text textAlign="center" paddingBottom="32px">
            Email us and we’ll get back to you as soon as possible.
          </Text>
          <Link
            onClick={() => trackEvent(TRACK.supportLinkClicked)}
            openInNewTab
            color="primaryInverse"
            fullWidth
            hideIcon
            href={`mailto:${email}`}
            type="CTA"
          >
            <Icon style={{ marginRight: '10px' }} icon="Envelope" color="primaryInverse" />
            Email us
          </Link>
        </ContactMethodContainer>
        {!isSmb && (
          <>
            <Separator innerText="or" py={0} paddingLeft="32px" paddingRight="32px" />
            <ContactMethodContainer>
              <Text textAlign="center">
                <Icon icon="Phone" color="accent9" margin={{ right: '8px' }} /> Call us at{' '}
                <Link
                  color="primary"
                  href={`tel:1-${phoneNumber}`}
                  track={TRACK.supportLinkClicked}
                >
                  {phoneNumber}
                </Link>
                .
              </Text>
            </ContactMethodContainer>
          </>
        )}
      </Dialog>
    </>
  );
};
